
//Remove lazy-render styles after first load
window.addEventListener('load', function () {
  var elementsExcluded = document.querySelectorAll('.nitro-lazy-render');
  elementsExcluded.forEach(function (element) {
    element.classList.remove('nitro-lazy-render');
  });
});

/* Imports
-------------------------------------------------------------- */

// @codekit-prepend "js/jquery.lettering.js";
// @codekit-prepend "js/jquery.nice-select.min.js";
// @codekit-prepend "js/slick.js";

/* Sliders
-------------------------------------------------------------- */

jQuery(".testimonials__slider").slick({
  useTransform: true,
  cssEase: "ease-in-out",
  speed: 1000,
  dots: true,
  speed: 1000,
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows: false,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

jQuery(".case-results__slider")
  .slick({
    useTransform: true,
    cssEase: "ease-in-out",
    speed: 1000,
    dots: false,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: ".case-results__arrow--prev",
    nextArrow: ".case-results__arrow--next",
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  })
  .on("setPosition", function (event, slick) {
    slick.$slides.css("height", slick.$slideTrack.height() + "px");
  });

jQuery(".trust-logos__slider").slick({
  useTransform: true,
  cssEase: "ease-in-out",
  speed: 1000,
  dots: true,
  speed: 1000,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: false,
  responsive: [
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

jQuery(".profile-slider__slick-slider").slick({
  useTransform: true,
  cssEase: "ease-in-out",
  speed: 1000,
  speed: 1000,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  arrows: true,
  prevArrow: ".profile-slider__arrow--prev",
  nextArrow: ".profile-slider__arrow--next",
  responsive: [
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

jQuery(".team-slider__items").slick({
  useTransform: true,
  cssEase: "ease-in-out",
  speed: 1000,
  dots: false,
  speed: 1000,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  prevArrow:
    '<button class="slick-prev slick-arrow"><svg width="73" height="62" viewBox="0 0 73 62" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_21_16)"><path d="M30.6138 61.3862L0.61384 31.3862L30.6138 1.3862L34.0314 4.80377L10.4712 28.3662L72.3862 28.3655L72.3862 33.1986L9.26423 33.1992L34.0314 57.9686L30.6138 61.3862Z" fill="#8F1A1D"/></g><defs><clipPath id="clip0_21_16"><rect width="61" height="72" fill="white" transform="translate(72.5 0.5) rotate(90)"/></clipPath></defs></svg></button>',
  nextArrow:
    '<button class="slick-next slick-arrow"><svg width="73" height="62" viewBox="0 0 73 62" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_21_16)"><path d="M42.3862 0.613829L72.3862 30.6138L42.3862 60.6138L38.9686 57.1963L62.5288 33.6338L0.613771 33.6346L0.613771 28.8014L63.7358 28.8008L38.9686 4.0314L42.3862 0.613829Z" fill="#8F1A1D"/></g><defs><clipPath id="clip0_21_16"><rect width="61" height="72" fill="white" transform="translate(0.5 61.5) rotate(-90)"/></clipPath></defs></svg></button>',
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
      },
    },
  ],
});

/* Internal FAQ
-------------------------------------------------------------- */
let $internalFAQs = jQuery("section.internal-faq .items .item .heading");
if ($internalFAQs.length) {
  $internalFAQs.on("click", function (e) {
    jQuery(this).parent().toggleClass("open");
  });
}
/* NEW FAQ
-------------------------------------------------------------- */
if (jQuery(".flex-content.faqs").length) {
  jQuery(".flex-content.faqs .heading").click(function () {
    var $item = jQuery(this).parent(".item");
    if ($item.hasClass("open")) {
      $item.removeClass("open");
      return;
    }
    //jQuery( ".scholarship-faqs__items .item" ).removeClass( "open" );
    $item.addClass("open");
  });
}

/* Smooth Scroll
-------------------------------------------------------------- */

jQuery(".smooth-scroll").click(function (event) {
  jQuery("html,body").animate(
    { scrollTop: jQuery(this.hash).offset().top },
    1500
  );
});

/* Custom JS
-------------------------------------------------------------- */
document.addEventListener("DOMContentLoaded", function () {
  // Select last word with lettering.js
  jQuery(".last-word").lettering("words");

  // NiceSelect.js
  jQuery("select").niceSelect();
  jQuery("select").niceSelect("update");

  // Mobile menu button
  jQuery(".mobile-nav-btn").on("click", function () {
    jQuery(".top-nav__nav").toggle();
  });

  // Show sub-menus
  jQuery(".top-nav .menu-item-has-children a").on("click", function () {
    jQuery(this).siblings(".sub-menu").toggle();
  });

  // Hero line heights
  let hpHeroHeight = jQuery(".hp-hero").outerHeight();
  let internalHeroHeight = jQuery(".internal-hero").outerHeight();
  let navHeight = jQuery(".top-nav__inner").outerHeight();

  let internalHeroAccentLineHeight = internalHeroHeight - navHeight - 37;
  let heroAccentLineHeight = hpHeroHeight - navHeight - 27;

  jQuery(".internal-hero__line-accent").css(
    "height",
    internalHeroAccentLineHeight
  );

  jQuery(".hp-hero__line-accent").css("height", heroAccentLineHeight);

  // Wrap iframes in content with wrapper to allow for full width
  jQuery(".general-content__main iframe").wrap(
    "<div class='iframe-container'></div>"
  );
  jQuery(".scheme").on("click", function () {
    jQuery(".scheme").removeClass("active");
    jQuery(this).addClass("active");

    var currentColorScheme = jQuery(this).attr("data-scheme");

    jQuery("body").removeAttr("data-color-scheme");
    jQuery("body").attr("data-color-scheme", currentColorScheme);
  });

  jQuery(".links-content__link").on("click", function (e) {
    e.preventDefault();
    jQuery(".links-content__link").removeClass("active");
    jQuery(this).addClass("active");
    jQuery(".links-content__content-wrapper .content-box").removeClass(
      "active"
    );
    let boxId =
      ".links-content__content-wrapper #content-box-" +
      jQuery(this).data("lid");
    jQuery(boxId).addClass("active");
  });

  /* Practice Area Modal
	-------------------------------------------------------------- */
  jQuery("#practice-areas .pa-box.modal-yes").on("click", function () {
    jQuery("#pa-modal .inner").empty();
    jQuery(this).find(".pa-popup").clone().appendTo("#pa-modal .inner");
    jQuery(".pa-modal-container").addClass("open");
    jQuery("#pa-modal").addClass("open");
  });

  jQuery("#pa-modal .close-modal").on("click", function () {
    jQuery(".pa-modal-container").removeClass("open");
    jQuery("#pa-modal").removeClass("open");
  });
});
